export class ContactRequest {
    name = '';
    phoneNumber = '';
    message = '';
}
